import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { RecoveryCodes } from "../login/RecoveryCodes";
import { SecondFactorForm } from "./SecondFactorForm";
import { StepDialog } from "./StepDialog";

// Account settings: 10 new recovery codes (shown once); the old ones stop working.
export const NewCodesDialog = ({ open, onOpenChange }) => {
  const { newRecoveryCodes } = useAuth();
  const [codes, setCodes] = useState(null);
  const close = (next) => { if (!next) setCodes(null); onOpenChange(next); };

  const confirm = async (body) => {
    const data = await newRecoveryCodes(body);
    setCodes(data.recovery_codes);
    toast.success("New recovery codes made. The old ones no longer work.");
  };

  return (
    <StepDialog
      open={open}
      onOpenChange={close}
      testid="new-codes-dialog"
      title={codes ? "Your new recovery codes" : "Make new recovery codes"}
      description={codes ? null : "All 10 old codes stop working. Confirm it's you first."}
      hideTitle={!!codes}
    >
      {codes
        ? <RecoveryCodes codes={codes} onContinue={() => close(false)} />
        : <SecondFactorForm onConfirm={confirm} label="Make new codes" />}
    </StepDialog>
  );
};
